<!-- =========================================================================================
    File Name: ItemListView.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div class="vx-row item-details no-gutter">
        <div class="vx-col sm:w-1/4 w-full item-img-container bg-white flex items-center justify-center">
            <router-link :to="'/pages/product/'+getItemIdForLink(item)">
                <img data-v-576be5c6 v-if="item.image" v-bind:src="item.image" class="grid-view-img p-4">
            </router-link>
        </div>
        <div class="vx-col sm:w-1/2">
            <div class="p-4">
                <router-link :to="'/pages/product/'+getItemIdForLink(item)" class="item-name font-semibold mb-1">{{ item.FullTitle }} <span v-if="item.provider_id !== 3" style="font-weight: 500;font-size: 11px;">({{ item.Sku }})</span></router-link>

                <router-link v-if="item.provider_id !== 3" :to="'/pages/product/'+getItemIdForLink(item)" style="font-size: 11px;color: #626262;display: block" class="mt-1">
                    {{ item.Description }}
                </router-link>

                <p v-if="checkout && (userInfo.type_id === 3 || userInfo.type_id === 4)" class="mt-2 font-bold text-sm">
                    {{ $t('quantity') }}: {{ quantity }} <template v-if="item.provider_id === 3"><br>{{ item.additional_data.adobe.Level_Detail }}</template>
                </p>

                <div class="mt-2" style="font-size: 11px;" v-if="userInfo.type_id === 3 || userInfo.type_id === 4" :class="!item.is_returnable ? 'text-danger font-semibold' : 'font-light'">
                    {{ $t('note') }}: {{ item.is_returnable ? $t('returnable') : $t('not_returnable') }}
                </div>
            </div>
        </div>
        <div class="vx-col sm:w-1/4 w-full flex items-center">
            <div class="p-4 flex flex-col w-full border border-solid d-theme-border-grey-light border-r-0 border-t-0 border-b-0">
                <div v-if="userInfo.type_id === 3 || userInfo.type_id === 4" class="my-3 mt-0">
                    <navbar-fast-checkout v-if="checkout" :item="item" />
                    <div v-else>
                        <template v-if="item.provider_id !== 3">
                            <h5 v-if="!userInfo.need_azn_cash" class="font-bold text-center text-xl">${{ parseFloat(showAmount) }}</h5>
                            <div v-else>
                                <h5 v-if="userInfo.need_azn_cash" class="font-bold text-center text-xl"><vs-radio v-model="sell_type" :vs-value="1" :vs-name="'radio_'+item.id">{{ $t('cash') }}: {{ parseFloat(showAmountCash) }} AZN</vs-radio></h5>
                                <h5 v-if="userInfo.need_azn_credit" class="font-bold text-center text-xl"><vs-radio v-model="sell_type" :vs-value="2" :vs-name="'radio_'+item.id">{{ $t('credit') }}: {{ parseFloat(showAmountCredit) }} AZN</vs-radio></h5>
                            </div>
                        </template>
                    </div>

                    <div v-if="!checkout && (userInfo.type_id === 3 || userInfo.type_id === 4) && item.provider_id !== 3" class="text-center">
                        <div class="vs-input-number inline-flex vs-input-number-size-null vs-input-number-primary">
                            <button type="button" class="btn-less vs-input-number--button-less limit" ref="btnLess" @click="minus()">
                                <i class="vs-icon notranslate icon-scale material-icons null">remove</i>
                            </button>
                            <input type="number" :value="quantity" v-on:keyup="changeQuantity" class="vs-input-number--input" style="width: 9.1px;" ref="quantityInput">
                            <button type="button" class="btn-plus vs-input-number--button-plus" @click="plus()">
                                <i class="vs-icon notranslate icon-scale material-icons null">add</i>
                            </button>
                        </div>
                    </div>

                </div>
                <div v-else>
                    <div class="vx-row">
                        <div class="vx-col w-1/2" style="display: flex;align-items: center;">Markup:</div>
                        <div class="vx-col w-1/2">
                            <select v-model="selectedMarkup" class="input-select vs-select--input">
                                <option :key="key" :value="key" v-for="(item,key) in item.Amounts.markups">{{ key }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col w-1/2">Royalty:</div>
                        <div class="vx-col w-1/2">{{ item.Amounts.Royalty }}$</div>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col w-1/2">Gold:</div>
                        <div class="vx-col w-1/2">{{ item.Amounts.markups[selectedMarkup].Gold }}$</div>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col w-1/2">Silver:</div>
                        <div class="vx-col w-1/2">{{ item.Amounts.markups[selectedMarkup].Silver }}$</div>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col w-1/2">Regular:</div>
                        <div class="vx-col w-1/2">{{ item.Amounts.markups[selectedMarkup].Regular }}$</div>
                    </div>
                </div>
                <template v-if="item.provider_id != 3">
                    <vs-button v-if="!checkout && (userInfo.type_id === 3 || userInfo.type_id === 4)" icon-pack="feather" icon="icon-shopping-bag" class="text-sm font-semibold" @click="addToBasket()">{{ $t('addToCart') }}</vs-button>
                </template>
                <template v-else>
                    <vs-button v-if="!checkout && userInfo.type_id === 3" icon-pack="feather" icon="icon-shopping-bag" class="text-sm font-semibold" @click="$router.push('/pages/product/'+getItemIdForLink(item))">{{ $t('makeAnOrder') }}</vs-button>
                </template>
            </div>
        </div>

    </div>
</template>

<script>
    import NavbarFastCheckout from "../../components/vx-card/NavbarFastCheckout";

    export default{
        props: {
            item: {
                type: Object,
                required: true
            },
            checkout: {
                type: Boolean,
                required: true
            },
            quantity: {
                type: Number,
                required: false,
                default: 1
            }
        },
        components: {
            NavbarFastCheckout
        },
        data() {
            return {
                userInfo: window.userInfo,
                showAmount: 0,
                sell_type: 1,
                showAmountCash: 0,
                showAmountCredit: 0,
                selectedMarkup: 0,
            }
        },
        methods: {
            getItemIdForLink(item){
                if (item.provider_id == 3){
                    if (item.additional_data == undefined) return item.id;
                    if (item.additional_data.adobe == undefined) return item.id;

                    return item.additional_data.adobe.product_id_for_show;
                }

                return item.id;
            },
            plus(){
                this.$refs.btnLess.classList.remove("limit");
                this.quantity++;
                this.updateQuantity();
            },
            minus(){
                if (this.quantity === 1) return;
                if (this.quantity === 2) this.$refs.btnLess.classList.add("limit");
                this.quantity--;
                this.updateQuantity();
            },
            changeQuantity(event){
                let value = event.target.value;
                value = parseInt(value.replace(/[^0-9]/g, ''));

                if (Number.isNaN(value)) value = 1;
                if (!Number.isInteger(value)) value = 1;
                if (value < 1) value = 1;

                if(value > 1) this.$refs.btnLess.classList.remove("limit");
                else this.$refs.btnLess.classList.add("limit");

                this.quantity = value;
                this.$refs.quantityInput.value = this.quantity;
                this.updateQuantity();
            },
            updateQuantity(){
                this.showAmount = (this.item.Amount * this.quantity).toFixed(2);
                this.showAmountCash = (this.item.cash * this.quantity).toFixed(2);
                this.showAmountCredit = (this.item.credit * this.quantity).toFixed(2);
            },
            addToBasket(){
                const thisIns = this;
                this.$vs.loading();
                axios.get(apiUrl+'/basket/add/'+this.item.id+'/'+this.quantity+'/'+this.sell_type+'?token='+token)
                    .then(function (response) {

                        let data = response.data;
                        if(data.code === 200){
                            thisIns.$store.dispatch('basket/reloadData', data.data);
                        }else{
                            if (data.code === 401){
                                window.logout();
                            }
                            thisIns.$vs.notify({
                                title: 'Error',
                                text:  data.message,
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle'
                            });
                        }
                        window.updateMyProfile();
                        thisIns.$vs.loading.close();
                    });
            },
        },
        created() {
            if (this.userInfo.type_id === 3 || this.userInfo.type_id === 4){

            }
            else{
                this.selectedMarkup = Object.keys(this.item.Amounts.markups)[0];
            }
            this.showAmount = (this.item.Amount * this.quantity).toFixed(2);
            if (this.userInfo.need_azn_cash){
                this.showAmountCash = (this.item.cash * this.quantity).toFixed(2);
                this.showAmountCredit = (this.item.credit * this.quantity).toFixed(2);
            }

        }
    }
</script>

<style lang="scss" scoped>

    .list-view-item .item-name[data-v-576be5c6], .list-view-item .item-description[data-v-576be5c6] {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }
    .list-view-item .item-name[data-v-576be5c6] {
        -webkit-line-clamp: 2;
    }
    .list-view-item .item-description[data-v-576be5c6] {
        -webkit-line-clamp: 5;
    }
    .list-view-item .grid-view-img[data-v-576be5c6] {
        max-width: 100%;
        max-height: 150px;
        width: auto;
        -webkit-transition: .35s;
        transition: .35s;
    }
    .list-view-item[data-v-576be5c6]:hover {
        -webkit-transform: translateY(-5px);
        transform: translateY(-5px);
        -webkit-box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.25);
        box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.25);
    }
    .list-view-item:hover .grid-view-img[data-v-576be5c6] {
        opacity: 0.9;
    }
</style>
